import axios from "axios";

const token = localStorage.getItem("wow-delivery-kw-merchant-token");

const PATCH = async (endpoint, data) => {
  const response = await axios.patch(endpoint, data, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response;
};

export default PATCH;
